import { useState } from 'react';
import { assessmentAPI, ApiResult } from '../../../../services/api';

interface UseAssessmentContactReturn {
  contactSubmitted: boolean;
  contactSubmitting: boolean;
  showContactModal: boolean;
  setShowContactModal: React.Dispatch<React.SetStateAction<boolean>>;
  handleContactSubmission: (contactData: Record<string, unknown>) => Promise<ApiResult>;
}

export const useAssessmentContact = (): UseAssessmentContactReturn => {
  const [contactSubmitted, setContactSubmitted] = useState(false);
  const [contactSubmitting, setContactSubmitting] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);

  const handleContactSubmission = async (contactData: Record<string, unknown>): Promise<ApiResult> => {
    setContactSubmitting(true);
    try {
      const result = await assessmentAPI.submitContact(contactData);
      if (result.success) {
        setContactSubmitted(true);
        setShowContactModal(false);
        return result;
      } else {
        throw new Error(result.error || 'Failed to submit contact information');
      }
    } catch (error) {
      console.error('Error submitting contact:', error);
      throw error;
    } finally {
      setContactSubmitting(false);
    }
  };

  return {
    contactSubmitted,
    contactSubmitting,
    showContactModal,
    setShowContactModal,
    handleContactSubmission
  };
};

export default useAssessmentContact;
